import React from 'react';
import { Toaster } from 'react-hot-toast';

export const ToastProvider = () => {
    return (
        <Toaster
            position="top-right"
            toastOptions={{
                duration: 4000,
                style: {
                    background: '#1f2937', // gray-800
                    color: '#fff',
                    border: '1px solid #374151', // gray-700
                },
                success: {
                    iconTheme: {
                        primary: '#10b981', // emerald-500
                        secondary: '#fff',
                    },
                },
                error: {
                    iconTheme: {
                        primary: '#ef4444', // red-500
                        secondary: '#fff',
                    },
                },
            }}
        />
    );
};
